module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-dialog', {
    attrs: {
      "fullscreen": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dark": "",
      "flat": "",
      "absolute": "",
      "color": "primary",
      "width": "100%"
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.dialogTitle))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "dark": ""
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_c('v-icon', [_vm._v("mdi-close")])], 1)], 1), _vm._v(" "), _c('v-card-title'), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "margin-top": "100px"
    }
  }, [(_vm.contract.influencer_details) ? _c('v-container', [_c('v-tabs', {
    attrs: {
      "centered": ""
    },
    model: {
      value: (_vm.selectedTab),
      callback: function($$v) {
        _vm.selectedTab = $$v
      },
      expression: "selectedTab"
    }
  }, [_c('v-tabs-slider'), _vm._v(" "), _c('v-tab', [_vm._v("\n                Invoice\n              ")]), _vm._v(" "), _c('v-tab', [_vm._v("\n                Brief Details\n              ")]), _vm._v(" "), (_vm.hideRequiredActions()) ? _c('v-tab', [_vm._v("\n                Email Template\n              ")]) : _vm._e(), _vm._v(" "), _c('v-tab-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "center"
    }
  }, [_c('img', {
    staticClass: "contract-logo",
    attrs: {
      "src": _vm.logoUrl
    }
  })])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('p', {
    staticStyle: {
      "margin": "0px 20px 0px 0px",
      "font-weight": "600"
    }
  }, [_vm._v("\n                        Kobe Global Technologies Pte Ltd."), _c('br'), _vm._v("\n                        GST Registration no. 201608755R"), _c('br'), _vm._v("\n                        51 Goldhill Plaza"), _c('br'), _vm._v("\n                        #14-01"), _c('br'), _vm._v("\n                        Singapore 308900"), _c('br'), _vm._v("\n                        finance@getkobe.com\n                      ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "border-bottom": "1px solid black",
      "padding": "5px",
      "color": "white"
    }
  }, [_vm._v("\n                        Content Creator Details\n                      ")]), _vm._v(" "), (_vm.contract.influencer_details.platform === 'tiktok') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        TikTok Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : (_vm.contract.influencer_details.platform === 'instagram') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        Instagram Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : (_vm.contract.influencer_details.platform === 'youtube') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        Youtube Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : (_vm.contract.influencer_details.platform === 'twitter') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        X (Twitter) Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : (_vm.contract.influencer_details.platform === 'others') ? _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm._f("platformDisplayName")(_vm.contract.influencer_details.platformName)) + " Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')]) : _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_vm._v("\n                        Platform Handle: " + _vm._s(_vm.contract.influencer_details.userHandle) + "  "), _c('br')])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "border-bottom": "1px solid black",
      "padding": "5px",
      "color": "white"
    }
  }, [_vm._v("Company Rep Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('strong', [_vm._v("Kobe Global Technologies Pte Ltd.")]), _vm._v(" "), _c('br'), _vm._v("\n                        (+65) 6255 5662 "), _c('br'), _vm._v("\n                        finance@getkobe.com\n                      ")])])])], 1), _vm._v(" "), _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "border-bottom": "1px solid black",
      "padding": "5px",
      "color": "white"
    }
  }, [_vm._v("Campaign Details")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    }
  }, [_c('strong', [_vm._v(_vm._s(_vm.contract.brief.campaignName))]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._v("\n                        Campaign Ref: " + _vm._s(_vm.contract.campaignID) + "\n                      ")])])])], 1), _vm._v(" "), (_vm.contract.deliverables && _vm.showDeliverables) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('table', {
    staticStyle: {
      "width": "100%",
      "border-top": "1px solid black"
    }
  }, [_c('thead', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "color": "white"
    }
  }, [_c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("DESCRIPTION")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("QTY")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("AMOUNT")])])]), _vm._v(" "), _c('tbody', [(_vm.contract.deliverables.no_of_stories) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Story")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_stories))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_stories')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_tiktok_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("TikTok Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_tiktok_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_tiktok_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_xhs_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("XHS Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_xhs_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_xhs_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_fb_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Facebook ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_fb_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_fb_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_carousels) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Carousel")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_carousels))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_carousels')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_video) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Video")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_video))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_video')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_igTv) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG TV")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_igTv))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_igTv')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_reels) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("IG Reels")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_reels))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_reels')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_li_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("LinkedIn Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_li_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_li_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.no_of_x_posts) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("X (Twitter) Post")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.no_of_x_posts))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('no_of_x_posts')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.youtube) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Youtube")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.youtube))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('youtube')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.loading_whitelisting) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Loading/Whitelisting")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.loading_whitelisting))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('loading_whitelisting')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.exclusivity) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Exclusivity ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.exclusivity))]), _vm._v(" "), (_vm.checkShowAmountRowSpan('exclusivity')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.physical_attendance) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Physical Attendance ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.physical_attendance) + "hrs")]), _vm._v(" "), (_vm.checkShowAmountRowSpan('physical_attendance')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverables.online_attendance) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("Online Attendance ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.contract.deliverables.online_attendance) + "hrs")]), _vm._v(" "), (_vm.checkShowAmountRowSpan('online_attendance')) ? _c('td', {
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "rowspan": _vm.getRowSpanCount
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._l((_vm.contract.deliverables.custom), function(custom, index) {
    return _c('tr', {
      key: index,
      staticStyle: {
        "border-left": "1px solid black"
      }
    }, [_c('td', [_vm._v(_vm._s(custom.label))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(custom.value))]), _vm._v(" "), (index === 0 && _vm.checkShowAmountRowSpan('custom')) ? _c('td', {
      staticStyle: {
        "text-align": "center"
      },
      attrs: {
        "rowspan": _vm.getRowSpanCount
      }
    }, [_vm._v(_vm._s(_vm.formatPayout(_vm.chkPayoutGST)))]) : _vm._e()])
  }), _vm._v(" "), _vm._l((_vm.contract.payout_details.boostingFees), function(boostingFee, index) {
    return (_vm.contract.payout_details) ? _c('tr', {
      key: index,
      staticStyle: {
        "border-left": "1px solid black"
      }
    }, [_c('td', {
      attrs: {
        "colspan": "2"
      }
    }, [_vm._v(_vm._s(boostingFee.label))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "center"
      }
    }, [_vm._v(_vm._s(_vm.formatPayout(boostingFee.value)))])]) : _vm._e()
  }), _vm._v(" "), (_vm.contract.GST) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', [_vm._v("\n                              GST\n                            ")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('td', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v(_vm._s(_vm.formatPayout(_vm.contract.GSTpercent)))])]) : _vm._e(), _vm._v(" "), (_vm.contract.deliverableNotes) ? _c('tr', {
    staticStyle: {
      "border-left": "1px solid black"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "3"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.contract.deliverableNotes))
    }
  })]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "border": "none !important"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "text-align": "center",
      "color": "white",
      "border-left": "1px solid black"
    },
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v(" TOTAL: " + _vm._s(_vm.formatPayout(_vm.contract.payout)) + " ")])])])], 2)])])])], 1) : _vm._e(), _vm._v(" "), (_vm.contract.invoiceRemarks) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', {
    staticStyle: {
      "border": "1px solid black"
    }
  }, [_c('div', {
    staticStyle: {
      "background-color": "#3F3FFF",
      "border-bottom": "1px solid black",
      "padding": "5px",
      "color": "white"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "5px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatDesc(_vm.contract.invoiceRemarks))
    }
  })])])], 1) : _vm._e(), _vm._v(" "), (_vm.showTerms) ? _c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "12",
      "lg": "12",
      "align": "left"
    }
  }, [_c('div', [_c('h1', [_vm._v("Terms and Conditions")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("I have read and accepted the terms of use ("), _c('a', {
    attrs: {
      "href": "https://www.getkobe.com/influencer-terms-use-agreement/",
      "target": "_blank"
    }
  }, [_vm._v("https://www.getkobe.com/influencer-terms-use-agreement/")]), _vm._v(").")]), _vm._v(" "), _c('li', [_vm._v("I have read and understood supporting campaign details that accompany this brief.")]), _vm._v(" "), _c('li', [_vm._v("I will not liaise with the Brand or the PR company, production company or any other agency involved in this campaign directly without consulting Kobe Global Technologies Pte Ltd for the duration of this campaign, and for the three months directly following job completion. If the Brand contacts me in this period for this campaign, I am under obligation to refer the client to Kobe Global Technologies Pte Ltd.")]), _vm._v(" "), _c('li', [_vm._v("I understand that the rate for this campaign is agreed upon before the commencement of the job and cannot be negotiated in any terms once the job is completed.")]), _vm._v(" "), _c('li', [_vm._v("I understand that the campaign brief and requirements may change and I am to provide updated availability and/or rates as required.")]), _vm._v(" "), _c('li', [_vm._v("Once I have received confirmation of the brief, I will submit all drafts in a timely manner and according to the requested guidelines from the client. I will ensure the post goes live by the date of deadline and and understand if this is not met, or the client has any complaints about my performance,\n                          I may forfeit my rate or be deducted a penalty by the client.")]), _vm._v(" "), _c('li', [_vm._v("I agree that any content submitted to Kobe pursuant to a Campaign Agreement and accepted by a Client shall remain publicly accessible through your social media account(s) for a minimum of six (6) months, or such greater term as specified in the Campaign Agreement.")]), _vm._v(" "), _c('li', [_vm._v("I own all of the content and information i create, in addition, the content that is covered by intellectual property rights, like photos and videos (IP content), You hereby represent and warrant that the content will be an original work of you and that the content will not infringe or misappropriate the intellectual property rights of any third party.")]), _vm._v(" "), _c('li', [_vm._v("I will submit my payout and all post statistics on https://app.getkobe.com/ once job has been completed in order for payment to be processed. Payment will be received within 45 days after payout submission on the platform and/or payment clearance from client, whichever earlier.")]), _vm._v(" "), _c('li', [_vm._v("If products are incorporated within the campaign, they should not be included for the purpose of sale or resale.")]), _vm._v(" "), _c('li', [_vm._v("The client is legally obligated to provide appropriate and conspicuous credit to the original creators whenever content is shared on their social media platforms. The client agrees that any actions involving boosting, paid promotion, or similar techniques for content amplification will only be undertaken with prior consent from the relevant parties.")])])])])], 1) : _vm._e()], 1), _vm._v(" "), _c('v-tab-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-row', [_c('v-col', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.briefDetailHTML)
    }
  })])], 1)], 1), _vm._v(" "), _c('v-tab-item', {
    staticStyle: {
      "margin-top": "20px"
    }
  }, [_c('v-row', [_c('v-col', {
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.users,
      "item-value": "id",
      "item-text": "name",
      "label": "From",
      "outlined": "",
      "dense": ""
    },
    on: {
      "change": _vm.searchFilter
    },
    model: {
      value: (_vm.selectedUser),
      callback: function($$v) {
        _vm.selectedUser = $$v
      },
      expression: "selectedUser"
    }
  })], 1)], 1), _vm._v(" "), (_vm.contract.influencer_details.platform === 'tiktok' || !_vm.contract.influencer_details.contact_details.email) ? _c('v-row', {
    staticClass: "mt-0"
  }, [_c('v-col', {
    staticClass: "pt-0",
    attrs: {
      "cols": "12",
      "sm": "12",
      "md": "3",
      "lg": "3"
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "Influencer Email",
      "outlined": "",
      "dense": ""
    },
    model: {
      value: (_vm.influencerEmail),
      callback: function($$v) {
        _vm.influencerEmail = $$v
      },
      expression: "influencerEmail"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('vue-editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.emailTemplateHTML),
      callback: function($$v) {
        _vm.emailTemplateHTML = $$v
      },
      expression: "emailTemplateHTML"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-row', {
    staticStyle: {
      "margin-bottom": "10px !important"
    }
  }, [_c('v-col', {
    staticStyle: {
      "margin-right": "20px"
    },
    attrs: {
      "cols": "12",
      "align": "right"
    }
  }, [_c('v-container', [_c('v-form', {
    ref: "form",
    attrs: {
      "lazy-validation": ""
    },
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.showOptions) ? _c('v-checkbox', {
    attrs: {
      "align": "right",
      "rules": [function (v) { return !!v || 'You must agree to continue!'; }],
      "label": "I have read and agree to the Terms and Conditions"
    },
    model: {
      value: (_vm.agreement),
      callback: function($$v) {
        _vm.agreement = $$v
      },
      expression: "agreement"
    }
  }) : _vm._e(), _vm._v(" "), _c('v-alert', {
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "text": "",
      "dismissible": "",
      "border": "left",
      "type": "error"
    },
    model: {
      value: (_vm.alert),
      callback: function($$v) {
        _vm.alert = $$v
      },
      expression: "alert"
    }
  }, [_vm._v("\n                 Please indicate that you have read and agree to the terms and conditions.\n                ")]), _vm._v(" "), (this.selectedTab === 0 || this.selectedTab === 1) ? _c('v-btn', {
    staticClass: "ma-2 white--text",
    attrs: {
      "loading": _vm.downloadloading,
      "disabled": _vm.downloadloading,
      "color": "blue-grey"
    },
    on: {
      "click": _vm.download
    }
  }, [_vm._v("Download\n                "), _c('v-icon', {
    attrs: {
      "right": "",
      "dark": ""
    }
  }, [_vm._v("mdi-cloud-download")])], 1) : _vm._e(), _vm._v(" "), (_vm.showSendButton) ? _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.sendClick
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-send")]), _vm._v("Send\n                ")], 1) : _vm._e(), _vm._v(" "), (_vm.showSubmitButton) ? _c('v-btn', {
    attrs: {
      "color": "success"
    },
    on: {
      "click": _vm.agreeClick
    }
  }, [_c('v-icon', {
    attrs: {
      "left": ""
    }
  }, [_vm._v("mdi-checkbox-marked-circle")]), _vm._v("Agree")], 1) : _vm._e(), _vm._v(" "), (_vm.showDeclineButton) ? _c('v-btn', {
    attrs: {
      "color": "error"
    },
    on: {
      "click": _vm.declineClick
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v(" mdi-cancel")]), _vm._v("Decline")], 1) : _vm._e(), _vm._v(" "), (_vm.showCancelButton) ? _c('v-btn', {
    attrs: {
      "color": "info"
    },
    on: {
      "click": _vm.cancelClick
    }
  }, [_c('v-icon', {
    attrs: {
      "dark": "",
      "left": ""
    }
  }, [_vm._v("mdi-minus-circle")]), _vm._v("Cancel")], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": "error",
      "rounded": "pill",
      "timeout": _vm.snackbarTimeout
    },
    scopedSlots: _vm._u([{
      key: "action",
      fn: function(ref) {
        var snackattrs = ref.snackattrs;

        return [_c('v-btn', _vm._b({
          attrs: {
            "color": "white",
            "text": ""
          },
          on: {
            "click": function($event) {
              _vm.snackbar = false
            }
          }
        }, 'v-btn', snackattrs, false), [_vm._v("\n          Close\n        ")])]
      }
    }]),
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.snackbarText) + "\n      ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0329f234"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Campaign/CampaignInvite/InfluencerContractModal.vue
// module id = 1974
// module chunks = 0